import * as React from "react";
import { MapPin } from "lucide-react";
export default function FindTheLab() {
  return <section data-section-id="127737" id="convenient-community-access" className="relative w-full min-h-[700px] bg-background text-foreground flex items-center py-12 lg:py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 bg-slate-950">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612706/img/physiopulse_dark_map_bg.png)] bg-cover bg-center opacity-40 grayscale contrast-125 mix-blend-luminosity"></div>
        
        {}
        <div className="absolute top-[40%] left-[50%] lg:left-[35%] -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
          <div className="relative flex items-center justify-center size-16 bg-primary/20 rounded-full animate-pulse">
            <div className="absolute inset-0 rounded-full border-2 border-primary/50 animate-ping"></div>
            <MapPin className="size-8 text-primary fill-primary/20" />
          </div>
          <div className="mt-3 px-4 py-1.5 bg-card/95 backdrop-blur-md text-card-foreground text-xs font-mono font-bold tracking-wider uppercase rounded-full shadow-xl border border-border/50">
            Freetown Family Clinic
          </div>
        </div>
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-6 flex justify-center lg:justify-end">
        <div className="w-full max-w-md bg-card/90 backdrop-blur-2xl border border-border/40 rounded-3xl shadow-2xl p-6 sm:p-8">
          {}
        </div>
      </div>
    </section>;
}